var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = (_a) => {
    var { tag: Icon, className, children, color, onClick } = _a, props = __rest(_a, ["tag", "className", "children", "color", "onClick"]);
    return (_jsx(Icon, Object.assign({ color: color, className: className, onClick: onClick }, props, { children: children })));
};
export default Icon;
